import FiltersSetterController, {
  TFilterSaveSelect,
} from './FiltersSettersController';
import { observer } from 'mobx-react-lite';
import { TApiaFilter } from '../../../../../types';
import { Select, validationsStore } from '@apia/validations';
import { reaction } from 'mobx';

const SelectFilterSetter = observer(
  ({
    controller,
    filter,
    i,
    handleChangingFilter,
  }: {
    controller: FiltersSetterController;
    filter: TFilterSaveSelect & {
      filter: TApiaFilter;
      readonly: boolean;
      required: boolean;
    };
    i: number;
    handleChangingFilter: (value: string, i: number) => void;
  }) => {
    reaction(
      () => controller.filters[i] as TFilterSaveSelect,
      (changingFilter: TFilterSaveSelect) => {
        const combo = validationsStore.getFieldStore(
          'FiltersSetter',
          filter.id,
        );
        combo.value = changingFilter.value;
      },
    );
    return (
      <Select
        name={filter.id}
        value={(controller.filters[i] as TFilterSaveSelect).value}
        validationRules={{ required: filter.required }}
        required={filter.required}
        disabled={filter.readonly}
        onChange={async (ev) => {
          (controller.filters[i] as TFilterSaveSelect).value = ev.target.value;
          handleChangingFilter(ev.target.value, i);
        }}
        options={(controller.filters[i] as TFilterSaveSelect).options.map(
          (op) => {
            return { label: op.label, value: op.value };
          },
        )}
      ></Select>
    );
  },
);

export default SelectFilterSetter;
